import { useTranslation } from "react-i18next";

const RewardsGrid = ({ items }) => {
    const { t } = useTranslation();
    return (
        <div className="mt-10">
            <h2 className="text-sm font-semibold text-primary">{t("HELP_REWARDS_LABEL")}</h2>
            <p className="mt-2 text-sm text-slate-500">
                {t("HELP_REWARDS_SUBTITLE")}
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 md:grid-cols-3 sm:gap-6 lg:grid-cols-4 xl:grid-cols-5">
                {items.map((item) => (
                    <div
                        key={item.labelKey}
                        className="flex h-full min-h-[430px] flex-col items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-6 text-center shadow-[0_10px_20px_rgba(15,23,42,0.06)]"
                    >
                        <div className="mx-auto flex min-h-[290px] min-w-[140px] flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#f1f0ee]">
                            <img src={item.image} alt="" className="h-full w-full object-cover" />
                        </div>
                        <p className="mt-5 min-h-[2.5rem] text-[11px] font-semibold uppercase tracking-[0.2em] text-primary line-clamp-2 leading-5">
                            {t(item.labelKey)}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RewardsGrid;
